import Card from "../../../components/UI/Card";
import CardCreateNewButton from "../../../components/UI/CardCreateNewButton";
import Table from "../../../components/UI/Table";
import React, {useState} from "react";
import {createColumnHelper} from "@tanstack/react-table";
import {getShippingCosts} from "../../../api/shippingCost";
import ShippingCostForm from "./__components/ShippingCostForm";
import ShippingCostListTableAction from "./__components/ShippingCostListTableAction";

export default function ShippingCostListPage() {
  const [openModal, setOpenModal] = useState(false)
  const [shippingCost, setShippingCost] = useState(null)

  const columnHelper = createColumnHelper();
  const columns = [
    columnHelper.accessor('min_quantity', {
      id: 'min_quantity',
      header: 'Min. Quantity',
    }),
    columnHelper.accessor('cost', {
      cell: info => '$' + info.getValue(),
      header: 'Cost'
    }),
    columnHelper.accessor('name', {
      id: 'name',
      header: 'Name',
    }),
    columnHelper.display( {
      id: 'actions',
      header: "Actions",
      classes:'text_right',
      cell: props => <ShippingCostListTableAction editRecord={(data)=>handleEditShippingCost(data)}  row={props.row.original} />
    }),
  ];

  const handleEditShippingCost = (data) => {
    setShippingCost(data)

    setOpenModal(true)
  }


  return (
    <>
      <Card title={"Shipping Cost"} CardActions={<CardCreateNewButton clickHandler={()=>handleEditShippingCost(null)} />}>
        <Table
          queryKey={"shipping_costs"}
          columns={columns}
          queryParams={{per_page: 10}}
          queryFn={getShippingCosts}
        />
      </Card>

      {openModal &&
        <ShippingCostForm editRecord={shippingCost}
                   openModal={openModal}
                   setShippingCost={setShippingCost}
                   setOpenModal={setOpenModal} />
      }
    </>
  );
}